import { render } from "./DraftImageUploadDialog.vue?vue&type=template&id=f4d54094&scoped=true"
import script from "./DraftImageUploadDialog.vue?vue&type=script&lang=js"
export * from "./DraftImageUploadDialog.vue?vue&type=script&lang=js"

import "./DraftImageUploadDialog.vue?vue&type=style&index=0&id=f4d54094&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4d54094"]])

export default __exports__